// The public header is sticky glass ~130px tall, so a raw anchor jump buries the
// heading underneath it. Every in-page nav link goes through here instead.
export const HEADER_OFFSET = 130;

export function scrollToSection(id) {
  if (id === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return true;
  }
  const el = document.getElementById(id);
  if (!el) return false;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET, behavior: "smooth" });
  return true;
}
